import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { range } from 'lodash';

export default class TimePicker extends React.Component {
  state = {
    timeChoices: [],
    startTime: '00:00',
    endTime: '00:00'
  };

  componentWillMount() {
    let times = [];
    range(24).forEach(i => {
      if (i < 10) {
        i = `0${i}`;
      }
      times = times.concat([`${i}:00`, `${i}:30`]);
    });
    this.setState({ timeChoices: times });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.startTime !== this.state.startTime ||
      prevState.endTime !== this.state.endTime
    ) {
      this.updateTime();
    }
  }

  updateTime() {
    this.props.onChange({
      startTime: this.state.startTime,
      endTime: this.state.endTime
    });
  }

  handleStartChange = event => {
    this.setState({ startTime: event.target.value });
  };

  handleEndChange = event => {
    this.setState({ endTime: event.target.value });
  };

  render() {
    const { timeChoices } = this.state;

    return (
      <div className="TimePicker">
        <div>
          <label>
            From{' '}
            <select className="start-select" onChange={this.handleStartChange}>
              {timeChoices.map((time, i) => (
                <option key={i} value={time}>
                  {moment(`1970-01-01 ${time}`).format('LT')}
                </option>
              ))}
            </select>
          </label>{' '}
          <label>
            to{' '}
            <select className="end-select" onChange={this.handleEndChange}>
              {timeChoices.map((time, i) => (
                <option key={i} value={time}>
                  {moment(`1970-01-01 ${time}`).format('LT')}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>
    );
  }
}

TimePicker.propTypes = {
  onChange: PropTypes.func,
  time: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Social/TimePicker.js